import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import useLocalStorage from '@cobliteam/hooks/src/useLocalStorage';
import type { IPreferencesValues } from '@cobliteam/preferences/src/Preferences';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';
import { useLocation } from 'react-router-dom';

const PREFERENCES_KEY = 'preferences';

const PageFavorite = () => {
  const [preferences, setPreferences] = useLocalStorage<IPreferencesValues>(PREFERENCES_KEY);
  const favoritePages = preferences?.favoritePages ?? [];
  const { pathname } = useLocation();
  const isFavorite = favoritePages.includes(pathname);

  const handleFavorite = () => {
    const newFavoritePages = isFavorite ? favoritePages.filter((url: string) => url !== pathname) : [...favoritePages, pathname];
    setPreferences({
      ...preferences,
      favoritePages: newFavoritePages,
    });
  };

  // 🔐 Feature Flag - Hide Favorite Button
  const featureFlags = useFeatureFlags();
  if (featureFlags.sidebar === true) return null;

  return <Button variant='ghost' size='sm' color='default' icon={<Icon name='star' className={cn(isFavorite && 'fill-primary text-primary')} />} onClick={handleFavorite} />;
};

export default PageFavorite;
